import { render, staticRenderFns } from "./MyTravelReservation.vue?vue&type=template&id=5bdaf0ab&"
import script from "./MyTravelReservation.vue?vue&type=script&lang=js&"
export * from "./MyTravelReservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports